// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Mpoy","left":"StickyBox_left__2qnhU","right":"StickyBox_right__20k-K"};